export default __webpack_public_path__ + "static/media/site-logo.d0fa99e2.png";